import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useState } from 'react';

import { UseFormatDate } from '../interfaces';
import { UseState } from '../types/useState.types';

export const useFormatDate: (language: string) => UseFormatDate = (language: string): UseFormatDate => {
  const [isReady, setIsReady]: UseState<boolean> = useState<boolean>(dayjs.locale() === language);
  if (!isReady) {
    import(`dayjs/locale/${language}.js`)
      .then(
        (): void => {
          dayjs.locale(language);
          setIsReady(true);
        })
      .catch((): void => setIsReady(false));
  }
  dayjs.extend(timezone);
  dayjs.extend(utc);

  const formatDate: (timestamp: number, format?: string) => string = (timestamp: number, format: string = 'YY-MM-DD'): string => {
    const timestampValue: number = `${timestamp}`.length === 13 ? timestamp / 1000 : timestamp;

    return isReady
      ? dayjs.unix(timestampValue).tz('Europe/Warsaw').format(format)
      : '';
  };

  return { formatDate, isReady };
};
